import React from 'react';
import { Icon } from '@surveycake/rc';
import { fileAltOutlined } from '@surveycake/rc';
import { timesOutlined } from '@surveycake/rc';
import { Typography } from '@surveycake/rc';
import { useStyles } from './styles';

export interface FileBlockProps {
  fileName: string;
  onRemove: () => void;
}

export default function FileBlock({ fileName, onRemove }: FileBlockProps) {
  const styles = useStyles();

  if (!fileName) {
    return null;
  }

  return (
    <div className={styles.file}>
      <Icon icon={fileAltOutlined} />
      <Typography className={styles.fileName} variant="span" noWrap>
        {fileName}
      </Typography>
      <span className={styles.remove} onClick={onRemove}>
        <Icon icon={timesOutlined} />
      </span>
    </div>
  );
}
